module.exports = __webpack_public_path__ + "img/btn-2.87055e22.png";